import axios from 'axios';
import { base_url, tokenConfig } from './common';


export function askOpenQuestionRequest(filters, new_message) {
  const body = {
    'new_message': new_message,
    'filters': filters,
  }
  return axios.post(`${base_url}ask_ai/ask_open_question`, body, tokenConfig());
}

export function get_answer_for_question_on_sessions({ page = 1, limit = 10, metadataFilters = [],startDate, endDate, messages=[] }) {
  const body = {
    page,
    limit,
    start_date: startDate,
    end_date: endDate,
    messages
  };

  // Add metadata filters to the request body if they exist
  if (metadataFilters.length > 0) {
    body.metadata_filters = metadataFilters.map((filter) => ({
      key: filter.field,
      condition: filter.condition,
      value: filter.value,
    }));
  }

  const url = `${base_url}ask_ai/ask_about_session_recordings`; // Use URL without query parameters for a POST request

  return axios.post(url, body, tokenConfig());
}

export function exportSessionRecordingData({ metadataFilters = [], startDate, endDate }) {
  const body = {
    start_date: startDate,
    end_date: endDate,
  };
  if (metadataFilters.length > 0) {
    body.metadata_filters = metadataFilters.map((filter) => ({
      key: filter.field || filter.key,
      value: filter.value,
      // Optionally add condition if your backend supports it
      ...(filter.condition ? { condition: filter.condition } : {})
    }));
  }
  const url = `${base_url}ask_ai/session_recording_data_export`;
  return axios.post(url, body, tokenConfig());
}